export default __webpack_public_path__ + "static/media/note.265158be.png";